import { useEffect, useRef, useState } from 'react';
const SAMPLE_INTERVAL_MS = 100;
const MIN_BAR = 0.15;
function getAudioContextClass() {
    const win = window;
    return win.AudioContext || win.webkitAudioContext;
}
export default function useLiveWaveform(mediaRecorder, isRecording, barCount = 28) {
    const [bars, setBars] = useState(null);
    const barsRef = useRef([]);
    useEffect(() => {
        if (!isRecording || !(mediaRecorder === null || mediaRecorder === void 0 ? void 0 : mediaRecorder.stream)) {
            setBars(null);
            barsRef.current = [];
            return;
        }
        const AudioContextClass = getAudioContextClass();
        if (!AudioContextClass)
            return;
        const padding = Math.max(0, barCount - barsRef.current.length);
        barsRef.current = [...new Array(padding).fill(MIN_BAR), ...barsRef.current].slice(-barCount);
        setBars(barsRef.current);
        let context;
        let source;
        try {
            context = new AudioContextClass();
            source = context.createMediaStreamSource(mediaRecorder.stream);
        }
        catch (err) {
            console.error('Live waveform unavailable', err);
            return;
        }
        const analyser = context.createAnalyser();
        analyser.fftSize = 256;
        source.connect(analyser);
        const data = new Uint8Array(analyser.fftSize);
        let frame;
        let lastSample = 0;
        const tick = () => {
            const now = performance.now();
            if (now - lastSample >= SAMPLE_INTERVAL_MS) {
                lastSample = now;
                analyser.getByteTimeDomainData(data);
                let peak = 0;
                for (let i = 0; i < data.length; i++) {
                    peak = Math.max(peak, Math.abs(data[i] - 128));
                }
                const amplitude = Math.max(MIN_BAR, Math.min(1, peak / 128));
                barsRef.current = [...barsRef.current, amplitude].slice(-barCount);
                setBars(barsRef.current);
            }
            frame = requestAnimationFrame(tick);
        };
        frame = requestAnimationFrame(tick);
        return () => {
            cancelAnimationFrame(frame);
            source.disconnect();
            context.close().catch(() => undefined);
        };
    }, [isRecording, mediaRecorder, barCount]);
    return bars;
}
